/**
 * Calculate the page number from an offset and page size
 * @param offset - The offset of the items or the start index
 * @param pageSize - The page size
 * @returns The page number
 */
export default function calculatePage(offset: number, pageSize: number): number {
  return Math.floor(offset / pageSize) + 1;
}
